import React, { useEffect, useRef } from 'react';
import Quagga from 'quagga';

const BarcodeScanner = ({ onScan }) => {
  const scannerRef = useRef(null);

  useEffect(() => {
    Quagga.init({
      inputStream: {
        type: 'LiveStream',
        target: scannerRef.current,
        constraints: {
          width: 640,
          height: 480,
          facingMode: 'environment'
        }
      },
      decoder: {
        readers: ['code_128_reader', 'ean_reader', 'ean_8_reader', 'code_39_reader', 'upc_reader', 'upc_e_reader']
      }
    }, (err) => {
      if (err) {
        console.error(err);
        alert('Camera not available');
        return;
      }
      Quagga.start();
    });

    Quagga.onDetected((result) => {
      const code = result.codeResult.code;
      Quagga.stop();
      if (onScan) onScan(code);
    });

    return () => {
      Quagga.stop();
    };
  }, [onScan]);

  return (
    <div 
      ref={scannerRef} 
      style={{ 
        width: '100%', 
        maxWidth: '640px', 
        height: '480px',
        marginBottom: '10px',
        border: '2px solid #ffc107'
      }} 
    />
  );
};

export default BarcodeScanner;
